<script setup lang="ts">
import { useRegionStore } from "@/stores/master/region";
import { mapOptionMultiselect } from "@/utils/helper";
import { defineComponent, ref, defineEmits } from "vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

const countryStore = useRegionStore();
const listCountry = ref<any>();
const country = ref("");
const search = ref("");

const loadListCountry = async () => {
  const { success, message } = await countryStore.dispatchGetCountry();
  if (success) {
    listCountry.value = mapOptionMultiselect(
      await countryStore.countries,
      "Id",
      "Name"
    );
  }
};

loadListCountry();

const emit = defineEmits(["searchByQuery"]);

const buildQuery = async () => {
  let queryTemp = "";

  if (search.value != "") {
    queryTemp = queryTemp + "&keyword=" + search.value;
  }

  if (country.value != "") {
    queryTemp = queryTemp + "&country=" + country.value?.label;
  }

  emit("searchByQuery", queryTemp);
};

const handleChooseCountry = async () => {
  buildQuery();
};
</script>

<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <div class="">
        <h4 class="fs-16 fw-medium mb-sm-0">Filter</h4>

        <form class="default-src-form mt-3">
          <div class="d-sm-flex flex-wrap gap-3 row">
            <div class="position-relative mb-2 mb-sm-0 col">
              <input
                type="text"
                class="form-control rounded-1"
                placeholder="Search Name"
                v-model="search"
                @keyup="buildQuery"
              />
              <i
                class="material-symbols-outlined position-absolute top-50 start-0 translate-middle-y fs-18"
              >
                search
              </i>
            </div>
            <div class="col">
              <vSelect
                :options="listCountry"
                name="country"
                v-model="country"
                placeholder="Choose Country"
                @close="handleChooseCountry"
              ></vSelect>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
